import { String_timeStringIsValid } from "./stringUtils";

export function Date_toDateTimeString(date: Date) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const hour = date.getHours().toString().padStart(2, "0");
    const minute = date.getMinutes().toString().padStart(2, "0");

    return `${year}-${month}-${day}T${hour}:${minute}`;
}

export function Date_toDateString(date: Date) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");

    return `${year}-${month}-${day}`;
}

export function Date_isSameDate(d0: Date, d1: Date): boolean {
    const isSameDate =
        d0.getDate() === d1.getDate() && d0.getMonth() === d1.getMonth() && d0.getFullYear() === d1.getFullYear();

    return isSameDate;
}

export function Date_isToday(date: Date): boolean {
    const current = new Date();

    const isToday = Date_isSameDate(date, current);
    return isToday;
}

export function Date_hasPassed(date: Date): boolean {
    const current = new Date();

    const hasPassed = date < current;
    return hasPassed;
}

export function Date_normalizeDateString(dateString: string): string {
    if (!dateString) {
        return "";
    }

    const normalized = dateString.includes("T") ? dateString.split("T")[0] : dateString;

    return normalized;
}

export function Date_dateStringIsValid(dateString: string): boolean {
    try {
        const date = new Date(dateString);
        return !isNaN(date.getTime());
    } catch (error) {
        return false;
    }
}

export function Date_isSameDateAndTime(d0: Date, d1: Date): boolean {
    const isSameDateTime =
        !!d0 &&
        !!d1 &&
        d0.getMinutes() === d1.getMinutes() &&
        d0.getHours() === d1.getHours() &&
        d0.getDate() === d1.getDate() &&
        d0.getMonth() === d1.getMonth() &&
        d0.getFullYear() === d1.getFullYear();

    return isSameDateTime;
}

export function Date_isSameMinuteOnly(d0: Date, d1: Date): boolean {
    const isSameMinuteOnly = !!d0 && !!d1 && d0.getMinutes() === d1.getMinutes() && d0.getHours() === d1.getHours();

    return isSameMinuteOnly;
}
export function Date_dateOnly(d: Date): Date {
    const date = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0);
    return date;
}

export function Date_currentDate(): Date {
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);

    return currentDate;
}

export function Date_toTimeString(date: Date): string {
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    const timeString = `${hours}:${minutes}`;

    return timeString;
}

export function Date_withTimeString(date: Date, time: string): Date {
    const isValidTime = String_timeStringIsValid(time);
    if (!isValidTime) {
        console.error("Invalid time string:", time);
        return date;
    }

    const split = time.split(":");
    if (split.length < 2) {
        console.error("Invalid time string:", time);
        return date;
    }

    const hours = Number.parseInt(split[0]);
    const minutes = Number.parseInt(split[1]);

    const updatedDate = new Date(date);
    updatedDate.setHours(hours, minutes, 0, 0);

    return updatedDate;
}

export function Date_hoursBetween(d0: Date, d1: Date): number {
    const diffInMs = Math.abs(d1.getTime() - d0.getTime());
    const diffInHours = diffInMs / (1000 * 60 * 60);

    return diffInHours;
}

export function Date_min(d0: Date, d1: Date): Date {
    return d0 < d1 ? d0 : d1;
}
